import { AsyncActionMetaOptions } from 'store/types';

import {
    GET_MAIN_MENU_CONFIG,
    GET_MAIN_MENU_CONFIG_FAILURE,
    GET_MAIN_MENU_CONFIG_REQUEST,
    GET_MAIN_MENU_CONFIG_SUCCESS,
    GET_TEMPLATEVIEW,
    GET_TEMPLATEVIEW_FAILURE,
    GET_TEMPLATEVIEW_REQUEST,
    GET_TEMPLATEVIEW_SUCCESS,
} from './constants';
import {
    MenuConfigurationItem,
    RBTemplateview,
    TemplateviewsById,
} from './reducer.types';

export function getMainMenuConfig(meta?: AsyncActionMetaOptions) {
    return { type: GET_MAIN_MENU_CONFIG, meta: meta || {} };
}

export function getMainMenuConfigRequest() {
    return { type: GET_MAIN_MENU_CONFIG_REQUEST };
}

export function getMainMenuConfigSuccess(
    standardMenu: MenuConfigurationItem[],
    kidsMenu: MenuConfigurationItem[],
) {
    return {
        type: GET_MAIN_MENU_CONFIG_SUCCESS,
        payload: {
            standardMenu,
            kidsMenu,
        },
    };
}

export function getMainMenuConfigFailure(error: any) {
    return { type: GET_MAIN_MENU_CONFIG_FAILURE, payload: { error } };
}

export function getTemplateview(
    id: keyof TemplateviewsById,
    meta: AsyncActionMetaOptions<RBTemplateview> = {},
) {
    return { type: GET_TEMPLATEVIEW, payload: { id }, meta };
}

export function getTemplateviewRequest(id: keyof TemplateviewsById) {
    return { type: GET_TEMPLATEVIEW_REQUEST, payload: { id } };
}

export function getTemplateviewSuccess(
    id: string,
    templateview: RBTemplateview,
) {
    return { type: GET_TEMPLATEVIEW_SUCCESS, payload: { id, templateview } };
}

export function getTemplateviewFailure(
    error: any,
    id: keyof TemplateviewsById,
) {
    return { type: GET_TEMPLATEVIEW_FAILURE, payload: { error, id } };
}
